import useTechnicalAlertsMapEntities from './useTechnicalAlertsMapEntities';

export default useTechnicalAlertsMapEntities;
